export const Gender = [
    { value: 'Male', label: 'Male' },
    { value: 'Female', label: 'Female' },
];
